<mat-expansion-panel [expanded]="true" hideToggle>
    <button mat-icon-button (click)="closeWindow()" color="warn" aria-label="Close" align="end" class="close-button">
        <mat-icon>close</mat-icon>
    </button>
    <mat-expansion-panel-header>
        <mat-panel-title>
            <legend>Reassign Workbench Item</legend>
        </mat-panel-title>
    </mat-expansion-panel-header>
    <mat-divider> </mat-divider>
     
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <div class="row">
            <div class="col">
                <h3>
                    <b>Current Editor: </b>
                    <span *ngIf="node?.NODE_EDITING?.length > 0">
                        <span class="bind-color bold">{{node.NODE_EDITING[0].LOGIN_DETAILS.PERSON.FIRST_NAME}}
                            {{node.NODE_EDITING[0].LOGIN_DETAILS.PERSON.LAST_NAME}}
                            ({{node.NODE_EDITING[0].LOGIN_DETAILS.USER_ID}})
                        </span>
                    </span>
                    <span *ngIf="!node?.NODE_EDITING?.length || node?.NODE_EDITING?.length == 0">
                        <span class="bind-color bold">N/A</span>
                    </span>
                </h3>
                <h3>
                    <b>Region: </b> <span class="bind-color bold">{{node?.NODE_REGIONS[0]?.REGION?.NAME}}
                        ({{node?.NODE_REGIONS[0]?.REGION?.CODE}})</span>
                </h3>
                <h3>
                   <b>Current Status: </b><span class="bind-color bold">{{node?.WORKFLOW_STATE_TYPES?.DESCRIPTION}}</span>
                </h3>
            </div>
        </div>
    </div>
    <mat-divider> </mat-divider>
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <form [formGroup]="frmChangeNodeState">
            <div class="row" style="margin-top: 5px;">
                <div class="col-lg-6" *ngIf="states">
                    <span *ngIf="loadingStates"><i class="fa fa-refresh fa-spin fa-fw"></i> Loading States</span>
                    <label>Choose the item's state to:</label>
                    <mat-form-field class="col-lg-12">
                        <mat-select formControlName="frmChosenState" placeholder="-- Select state --" (selectionChange)="loadUsersForSelectedState()">
                            <mat-option [value]="" >-- Select to state --</mat-option>
                            <mat-option *ngFor="let state of states;" [value]="state.ID">
                                {{ state?.DESCRIPTION }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <div class="row" style="margin-top: 5px;" *ngIf="users.length > 0">
                <div class="col-lg-6" *ngIf="users">
                    <span *ngIf="loadingUsers"><i class="fa fa-refresh fa-spin fa-fw"></i> Loading Users</span>
                    <label>Choose a user to reassign this item to:</label>
                    <mat-form-field class="col-lg-12">
                        <mat-select formControlName="frmChosenEditor" placeholder="-- Select user --" (selectionChange)="changeAssign($event)">
                            <mat-option [value]="" >-- Select user (optional)--</mat-option>
                            <mat-option *ngFor="let user of users; trackBy: trackByUserId" [value]="user.USER_ID">
                                {{ user?.PERSON?.FIRST_NAME + ' ' + user?.PERSON?.LAST_NAME + ' (' + user?.USER_ID + ')'}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
        </form>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <confirm-popover [type]="'button'" [buttonTxt]="'Transition'" [popoverTitle]="'Transition Workbench Item'"
            [popoverMsg]="'Are you sure you want to change the state of this item?'" [color]="'primary'"
            [disabled]="!assigning" (onConfirm)="changeNodeState()">
        </confirm-popover>
        <span class="bind-color" *ngIf="workflowStateTypes && workflowStateTypes?.ID">
            &nbsp;to <b>{{workflowStateTypes.DESCRIPTION}}</b>
            <span *ngIf="currentEditor?.ID"> and assign to <b>{{currentEditor.PERSON.FIRST_NAME}} {{currentEditor.PERSON.LAST_NAME}} ({{currentEditor.USER_ID}})</b></span>
        </span>
    </div>
</mat-expansion-panel>